import { SvgIcon } from "@mui/material";
import { ReactComponent as EthereumSvg } from "../../assets/ethereum.svg";

export function EthereumIcon() {
  return <SvgIcon component={EthereumSvg} inheritViewBox />;
}
